
import {
    createRouter,
    createWebHashHistory
} from 'vue-router' //引入vue-router
import index from '../pages/index'//首页
import team from '../pages/team'
import company from "@/pages/company";
import services from "@/pages/services"
import caseDetails from "@/pages/caseDetails";
import waterFall from "@/pages/waterFall";



const routes = [
    {
    path: '',
    redirect: "index"
   },
    {
    path: '/',
    redirect: "index" //重定向到首页
   },
    {
        path: '/index',
        name: 'index',
        component: index
    },
    {
        path: '/team',//团队介绍页面
        name: 'team',
        component: team
    },
    {
        path: '/company',
        name: 'company',
        component: company
    },


    {
        path: '/services',
        name: 'services',
        component: services
    },
    {
        path: '/services/:title',
        name: 'waterfall',
        component: waterFall
    },
    {
        path: '/services/:title:/:case',
        name: 'case_detail',
        component: caseDetails
    },

];

const router = createRouter({
    //mode: 'hash',三张模式：hash|history|abstract，默认hash
    history: createWebHashHistory(),
    routes
})
export default router;
